import { CONSTANT } from "src/app/constant";

/** Normalize route/API form type codes to `CONSTANT.FORM_TYPE` values. */
export function mapFormTypeCode(code?: string): string {
	if (!code) return "";

	const key = code.toString().toUpperCase().replace("_", "");
	const mapped = (CONSTANT.FORM_TYPE as Record<string, string>)[key];
	if (mapped) return mapped;

	const values = new Set(Object.values(CONSTANT.FORM_TYPE));
	if (values.has(code as (typeof CONSTANT.FORM_TYPE)[keyof typeof CONSTANT.FORM_TYPE])) return code;

	return "";
}
